import {
    Directive,
    Input,
    OnDestroy,
    Renderer2,
    AfterViewChecked,
    ElementRef
  } from '@angular/core';
  import { NgbPopover } from '@mattlewis92/ng-bootstrap/popover/popover.module';
  import { Subscription } from 'rxjs/Subscription';
  
  // temporary hack until https://github.com/ng-bootstrap/ng-bootstrap/pull/1602 is merged
  
  @Directive({
    selector: '[ngbPopover]' // tslint:disable-line
  })
  export class PopoverClassDirective implements OnDestroy, AfterViewChecked {
    @Input() popoverClass: string;
  
    private shownSubscription: Subscription;
  
    private hiddenSubscription: Subscription;
  
    private popoverWindowElm: ElementRef;
  
    constructor(private renderer: Renderer2, popover: NgbPopover) {
      this.shownSubscription = popover.shown.subscribe(() => {
        this.popoverWindowElm = popover['_windowRef'].location;
      });
      this.hiddenSubscription = popover.hidden.subscribe(() => {
        this.popoverWindowElm = null;
      });
    }
  
    ngAfterViewChecked(): void {
      if (this.popoverWindowElm && this.popoverClass) {
          this.popoverClass.split(' ').forEach((className:string) => {
              this.renderer.addClass(
                this.popoverWindowElm.nativeElement,
                className
              );
          })
      }
    }
  
    ngOnDestroy() {
      this.shownSubscription.unsubscribe();
      this.hiddenSubscription.unsubscribe();
    }
  }


// WEBPACK FOOTER //
// ./web/static/services/directives/PopoverClass.ts